/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum VendorOrderingFilterEnum {
  /**
   * Zoradiť od najstaršieho
   */
  CREATED_TIME = "CREATED_TIME",
  /**
   * Zoradiť od najnovšieho
   */
  CREATED_TIME_DESC = "CREATED_TIME_DESC",
  /**
   * ORDER_BY_LIKES
   */
  LIKES_COUNT = "LIKES_COUNT",
  /**
   * ORDER_BY_LIKES
   */
  LIKES_COUNT_DESC = "LIKES_COUNT_DESC",
  /**
   * ORDER_BY_RANDOM
   */
  RANDOM = "RANDOM",
  /**
   * ORDER_BY_RANDOM
   */
  RANDOM_DESC = "RANDOM_DESC",
  /**
   * Podľa počtu odporúčaní
   */
  USER_BRAND_COUNT = "USER_BRAND_COUNT",
  /**
   * Podľa počtu odporúčaní
   */
  USER_BRAND_COUNT_DESC = "USER_BRAND_COUNT_DESC",
}